import { useState } from 'react'
import { MetricCard } from '@/pages/home/components/MetricCard'
import { ContextsChart } from '@/pages/curation/components/ContextsChart'
import { PinnedExpressionsChart } from '@/pages/curation/components/PinnedExpressionsChart'
import { DateRange } from 'react-day-picker'

export default function CurationMetricsPage() {
  const [metricsPeriod, setMetricsPeriod] = useState<string | Date | DateRange>('24h')

  const handlePeriodChange = (period: string | Date | DateRange) => {
    setMetricsPeriod(period)
  }

  return (
    <div className="space-y-8">
      <div>
        <h2 className="font-sans font-semibold text-xl text-gray-900 mb-8">Métricas</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <MetricCard
            title="Conteúdos Utilizados em Reports"
            value={8}
            change={20}
            changeText="comparado a ontem."
            period={metricsPeriod}
            onPeriodChange={handlePeriodChange}
            onCardClick={() => console.log('Reports clicked')}
          />
          <MetricCard
            title="Conteúdos Favoritados"
            value={200}
            change={12}
            changeText="comparado a ontem."
            period={metricsPeriod}
            onPeriodChange={handlePeriodChange}
            onCardClick={() => console.log('Favorites clicked')}
          />
          <MetricCard
            title="Métrica"
            value={200}
            change={12}
            changeText="comparado a ontem."
            period={metricsPeriod}
            onPeriodChange={handlePeriodChange}
            onCardClick={() => console.log('Metric clicked')}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ContextsChart />
        <PinnedExpressionsChart />
      </div>
    </div>
  )
}
